const id = {
  swap: 'Tukar',
  bridge: 'Jembatan',
  markets: 'Pasar',
  comingSoon: 'Segera Hadir',
  copied: 'Disalin',
  searchTokens: 'Cari Token',
  recentSearches: 'Pencarian Terbaru',
  popularTokens: 'Token Populer',
  noSearchContent: 'Token tidak ditemukan.',
  tokenSearch: 'Pencarian Token',

  header: {
    buyToken: 'Beli Crypto',
    searchTokens: 'Cari Token',
    recentSearches: 'Pencarian Terbaru',
    popularTokens: 'Token Populer',
    noSearchContent: 'Token tidak ditemukan.',
    markets: 'Pasar',
    inscribeTool: 'Alat Inskripsi',
    trade: 'Dagang',
    bridge: 'Tukar&Jembatan',
    bridgeDesc:
      'Perdagangan dan jembatani token Anda melalui DEX kami dan agregator lintas rantai.',
    advanced: 'Lanjutan',
    advancedDesc:
      'Perdagangan dengan analisis data on-chain yang lebih komprehensif dan fitur perdagangan lanjutan.',
  },

  appSetting: {
    theme: 'Tema',
    light: 'Terang',
    dark: 'Gelap',
    auto: 'Otomatis',

    language: 'Bahasa',
    langText: 'Bahasa Inggris',

    showChart: 'Tampilkan Grafik',
    contactUs: 'Hubungi Kami',
  },

  stake: {
    know: {
      title: 'Staking TPT Dapatkan xTPT',
      desc: 'Staking TPT Anda untuk mendapatkan xTPT, yang dapat digunakan untuk memilih proposal perbaikan ekologi. Anda bisa menukar xTPT kembali ke TPT kapan saja.',
    },
    join: 'TPT yang Dipegang',
    connectWallet: 'Hubungkan Dompet',
    networkNotvalid: 'Silakan beralih ke jaringan BSC',
    approve: 'Setujui',
    unstake: 'Unstake',
    add: 'Tambahkan',
    loginFirst: '-',
    deposit: 'Deposit TPT',
    withdraw: 'Tarik TPT',
    balance: 'Saldo',
    confirm: 'Konfirmasi',
    overbalance: 'Saldo lebih dari yang tersedia',
    success: 'Berhasil',
    all: 'Semua',
    voteTip: 'Gunakan xTPT untuk memilih proposal yang Anda dukung!',
    goVote: 'Ayo Pilih',
  },

  fee: {
    desc: 'Transit Swap meluncurkan fungsi diskon biaya transaksi agregat, yang sesuai dengan tingkat diskon berdasarkan jumlah TPT dan xTPT yang dimiliki oleh alamat akun pengguna. Saat ini terdapat 4 level diskon, dan di masa depan, lebih banyak level akan dibagi sesuai situasi yang ada.',
    feeDiscount: 'Diskon Tarif',
    walletBalance: 'Saldo',
    levelRank: 'Level',
    levelBalance: 'Saldo (TPT dan xTPT)',
    levelDiscountRate: 'Tingkat Diskon',
  },

  donation: {
    know: {
      title: 'Definisi Dana Donasi Transit Swap:',
      desc: 'Sebagai bagian dari dunia blockchain terbuka, proyek Transit Swap menerima donasi Token dari pengguna individu, semua donasi akan dimasukkan ke dalam dana donasi yang akan digunakan untuk tujuan termasuk namun tidak terbatas pada operasi proyek Transit Swap dan pendanaan ekosistem terkait Transit Swap.',
    },
    tip: {
      title: 'Catatan Penting:',
      desc:
        'Proyek Transit Swap tidak menawarkan hadiah pasti kepada donor; donor yang ingin mengembalikan donasi mereka dalam 72 jam setelah hash donasi dapat melakukannya melalui formulir kontak resmi, tetapi permintaan pengembalian setelah batas waktu ini tidak akan diproses.\n' +
        'Jenis token donasi yang kami terima: TPT\n',
    },
    donateType: {
      title: 'Alamat Donasi yang Diterima',
      desc: 'TPT',
    },
    address: {
      title: 'Alamat Donasi yang Diterima:',
    },
    join: 'Donasi',
    donateChain: 'Pilih Jaringan',
    connectWallet: 'Hubungkan Dompet',
    donateTip: {
      title: 'Perhatian:',
      desc: 'Transit Swap tidak menawarkan hadiah pasti kepada donor; Jika Anda menyesal untuk mendonasikan, harap kirimkan hash transaksi ke email resmi dalam 72 jam untuk meminta pengembalian.',
    },
    warn: 'Harap pilih jaringan terlebih dahulu',
    transfer:
      'Harap gunakan TokenPocket untuk memindai QR Code ini untuk mendonasikan TPT',
    copyAddress: 'Salin alamat',
    copied: 'Disalin',
    yourAddress: 'Alamat Anda',
    cantDonate: 'Jaringan saat ini tidak mendukung donasi',
    confirmDonate: 'Konfirmasi donasi',
    donateSuccess: 'Berhasil',
    donateFail: 'Gagal',
    overCount: 'Saldo tidak cukup',
    donateAddress: 'Alamat Donasi',
    donateCount: 'Jumlah Donasi (TPT)',
    pleaseSwitch1: 'Harap beralih ke ',
    pleaseSwitch2: ' jaringan',
    downloadTP: 'Tidak bisa mendonasikan langsung, harap unduh TokenPocket',
    connectTronLink: 'Harap sambungkan TronLink terlebih dahulu',
    waitBlockConfirm: 'Dikirim',
    noZero: 'Jumlah donasi tidak bisa 0',
  },

  home: {
    title_1: 'Dengan Kekuatan Platform DEX Terdepan',
    title_2: 'Untuk Berdagang Seperti Profesional',
    swap: 'Tukar',
    bridge: 'Jembatan',
    startTrading: 'Mulai Berdagang',
    viewMore: 'Lihat Lebih Banyak',
    modal_contact_us: {
      title: 'Hubungi Kami',
      text_1:
        '* Harap dicatat bahwa Transit tidak akan pernah menghubungi Anda terlebih dahulu, kami juga tidak akan meminta Anda untuk membayar biaya.',
      text_2: 'Hubungi Transit Buy',
      serviceEmail: 'Email Layanan',
      telegram: 'Telegram',
      tips: 'Tersedia hanya jika pertanyaan mengenai OnRamp',
      desc1:
        'Staf Transit Finance tidak akan mengirim pesan pribadi kepada Anda!',
      desc2:
        'Perhatian! Anda sedang memasuki komunitas Transit, mungkin ada seseorang yang menyamar sebagai kami untuk mengirimkan pesan pribadi! Harap berhati-hati, siapa pun yang mengirim pesan pribadi mungkin adalah penipu! Kami tidak akan pernah menghubungi Anda terlebih dahulu!',
      desc3: 'Mengerti, masuk',
      tg_text_1:
        'Staf Transit Finance TIDAK AKAN menghubungi saya terlebih dahulu!',
      tg_text_2:
        'Siapa pun yang mengirim pesan pribadi kepada saya mungkin adalah penipu!',
      tg_text_3:
        'Saya tidak akan pernah membagikan informasi pribadi saya (termasuk frase sandi atau kunci pribadi) kepada siapa pun!',
    },
    markets: {
      title: 'Pasar',
      text: '<span>Dapatkan data real-time, temukan token populer, dan buat keputusan perdagangan yang lebih cerdas melalui fitur Pasar📈📉.</span>',
      text_1: 'Segera Hadir',
    },
    onRamp: {
      title: 'OnRamp',
      text: 'Berbagai saluran on/off-ramp untuk pembelian dan penjualan token yang optimal.',
    },
    swap_bridge: {
      title: 'Tukar & Jembatan',
      text: 'Menyatukan DEX terkemuka, mengoptimalkan perdagangan dengan harga terbaik dan profesionalisme yang tak tertandingi di berbagai rantai. Selain itu, kami menawarkan layanan jembatan lintas rantai profesional, memastikan likuiditas aset yang mulus.',
    },
    liquidity_options: {
      title: 'Data',
      text_1: 'Likuiditas yang lebih baik,',
      text_2: 'opsi yang lebih baik',
      Chains: 'Rantai',
      DEXs: 'DEXs',
      Bridges: 'Jembatan',
      Ramps: 'Ramps',
      Tokens: 'Token',
    },
    other_features: {
      title: 'Fitur Lain',
      NFT: {
        title: 'NFT',
        text_1: 'Pasar NFT',
        text_2: 'Transit NFT',
        text_3: 'Kompetisi Desain NFT',
      },
      Governance: {
        title: 'Tata Kelola',
        text_1: 'DAO',
        text_2: 'Donasi',
        text_3: 'Biaya',
      },
    },
    get_start: {
      text_1: 'Buka kemungkinan perdagangan tanpa batas dengan Transit',
      text_2: 'Untuk berdagang seperti seorang profesional!',
      text_3: 'Mulai Sekarang',
    },
  },

  terms: {
    title: 'Syarat & Ketentuan',
    text_1_1: 'Terakhir dimodifikasi: 1 Januari 2023',
    text_1_2:
      'Syarat Layanan ini (selanjutnya disebut sebagai "<strong>Syarat</strong>"), bersama dengan dokumen dan ketentuan tambahan yang dimasukkan sebagai referensi (secara kolektif disebut sebagai "<strong>Syarat</strong>"), dibuat oleh Transit dan afiliasinya atau perusahaan terkait (secara kolektif disebut sebagai "<strong>Transit</strong>," "<strong>kami</strong>," "<strong>milik kami</strong>," atau "<strong>kami</strong>") dan Anda atau perusahaan atau entitas hukum lainnya yang Anda wakili (secara kolektif disebut sebagai "<strong>Anda</strong>" atau "<strong>milik Anda</strong>").',
    text_1_3:
      'Harap baca Syarat ini dengan cermat karena ini mengatur penggunaan Anda terhadap situs web kami (selanjutnya disebut sebagai "<strong>Situs Web</strong>") dan produk, fitur, konten, aplikasi, atau layanan yang kami sediakan (secara kolektif disebut sebagai "<strong>Layanan</strong>"). Syarat ini menjelaskan hak dan kewajiban Anda serta penyangkalan dan pembatasan tanggung jawab hukum kami. Dengan mengakses atau menggunakan Situs Web atau Layanan kami, Anda menerima dan setuju untuk terikat dengan Syarat ini dan mematuhinya, termasuk klausul arbitrase wajib yang disebutkan dalam Syarat ini. Jika Anda tidak setuju dengan Syarat ini, Anda harus berhenti mengakses atau menggunakan Situs Web atau Layanan kami.',
    text_2_1: '1. PERUBAHAN PADA SYARAT INI',
    text_2_2:
      'Kami memiliki hak untuk mengubah Syarat ini kapan saja. Jika terjadi perubahan, kami tidak akan memberikan pemberitahuan lebih lanjut kepada Anda. Kecuali dinyatakan lain dalam pemberitahuan, setiap perubahan akan berlaku segera, dan penggunaan Anda atas situs web atau layanan kami yang berlanjut akan dianggap sebagai penerimaan terhadap perubahan tersebut. Jika Anda tidak setuju dengan Syarat yang diperbarui, Anda wajib berhenti menggunakan layanan kami.',
    text_3_1: '2. LAYANAN',
    text_3_2:
      '"Kontrak Cerdas" adalah program perangkat lunak sumber terbuka yang tersedia secara publik yang diterapkan di blockchain untuk memfasilitasi pertukaran P2P token berdasarkan blockchain.',
    text_3_3:
      '"Blockchain" adalah teknologi database yang didistribusikan yang didasarkan pada struktur jaringan desentralisasi, yang dipelihara dan diperbarui oleh beberapa node.',
    text_3_4:
      'Transit telah mengembangkan perangkat lunak yang memungkinkan pengguna untuk berinteraksi dengan kontrak cerdas Transit.',
    text_3_5:
      '"Jaringan Transit" terdiri dari semua pengguna, perusahaan, aplikasi, dan perangkat, layanan, atau personel lain yang berinteraksi dengan kontrak cerdas Transit di blockchain.',
    text_3_6:
      'Beberapa layanan yang kami sediakan atau partisipan lain dalam Jaringan Transit dapat memerlukan pembayaran atau melibatkan penggunaan blockchain atau infrastruktur terdesentralisasi atau berizin ("Teknologi Buku Besar Terdistribusi"), yang mungkin mengharuskan Anda membayar biaya, seperti biaya "gas" di jaringan Ethereum, untuk sumber daya komputasi yang diperlukan untuk mengeksekusi transaksi di Teknologi Buku Besar Terdistribusi tertentu (pembayaran dan biaya ini disebut secara kolektif sebagai "<strong>Biaya</strong>").',
    text_4_1: '3. SYARAT PENGGUNAAN',
    text_4_2:
      'Sebagai syarat penggunaan atau akses ke Layanan atau Situs Web, Anda harus:',
    text_4_3:
      '· Menggunakan Layanan dan Situs Web hanya untuk tujuan yang sah.',
    text_4_4:
      '· Memastikan bahwa semua informasi yang Anda berikan di Situs Web adalah terkini, lengkap, akurat, dan benar.',
    text_4_5: '· Mematuhi semua hukum dan peraturan yang berlaku.',
    text_5_1: '5. PEMEGANGAN HAK',
    text_5_2:
      'Kami berhak untuk menghentikan atau membatasi akses Anda ke atau penggunaan Layanan atau Situs Web kapan saja.',
  },

  privacy_policy: {
    title: 'Kebijakan Privasi',
    text_1_1: 'Terakhir Dimodifikasi: 2 Februari 2024',
    text_1_2:
      'Transit.Finance (selanjutnya disebut sebagai "<strong>kami</strong>", "<strong>perusahaan kami</strong>", atau "<strong>Perusahaan</strong>") berkomitmen untuk melindungi privasi Anda. Kebijakan Privasi ini (selanjutnya disebut sebagai "Kebijakan") dimaksudkan untuk menjelaskan kepada Anda bagaimana kami mengumpulkan, menggunakan, dan membagikan data pribadi Anda, serta hak-hak terkait Anda. Harap baca dengan seksama untuk memahami praktik privasi kami.',
  },

  footer: {
    Features: {
      title: 'Fitur',
      swap: 'Tukar&Jembatan',
      bridge: 'Jembatan',
      market: 'Pasar',
      buyCrypto: 'Beli Crypto',
      explorer: 'Penjelajah',
    },
    NFT: {
      title: 'NFT',
      design: 'Desain',
      transitNFT: 'Transit NFT',
      marketplace: 'Pasar NFT',
    },
    Governance: {
      title: 'Tata Kelola',
      dao: 'DAO',
      donation: 'Donasi',
      fee: 'Biaya',
    },
    Community: {
      title: 'Komunitas',
      developers: 'Pengembang',
      forum: 'Forum',
      twitter: 'Twitter',
      downloadTP: 'Unduh TP',
    },
    Help: {
      title: 'Bantuan',
      contactUs: 'Hubungi Kami',
      helpCenter: 'Pusat Bantuan',
    },
    Links: {
      title: 'Tautan',
      TP: 'TokenPocket',
      Trading_View: 'Tampilan Perdagangan',
      Terms: 'Syarat & Ketentuan',
      Privacy_Policy: 'Kebijakan Privasi',
      bugBounty: 'Bug Bounty',
    },
  },

  option: {
    vol: 'Volume',
    marketCap: 'MCAP',
    price: 'Harga',
    price_1: 'Harga',
    chg: 'Perubahan',
    change: 'Perubahan',
    bal: 'Saldo',
    pnl: 'Laba/Rugi',
    txCount: 'Txns',
    holderCount: 'Pemilik',
    createTime: 'Usia Token',
    token: 'Token',
    age: 'Usia',
    traders: 'Pedagang',
    name: 'Nama',
    progress: 'Progres Bonding',
    wallet: 'Dompet',
    balance: 'Saldo',
    pnl7d: '7D PnL',
    pnl30d: '30D PnL',
    txCount7d: '7D Txns',
    lastActive: 'Aktif Terakhir',
  },

  brandkit: {
    title: 'Aset Merek',
    download: 'Unduh Aset',
    desc: 'Di sini Anda dapat menemukan logo resmi Transit dan palet warna untuk membantu menampilkan merek kami secara tepat dalam proyek Anda. Kami mengundang Anda untuk menggunakan sumber daya ini sesuai pedoman merek agar Transit selalu konsisten dan profesional.',
    logoDownload: 'Unduh Logo',
    logoDownloadDesc:
      'Unduh logo merek kami sekarang untuk memastikan proyek desain Anda tetap konsisten dan profesional.',
    logoDownloadDesc_1:
      'Semua file berkualitas tinggi dan cocok untuk web, cetak, serta berbagai aplikasi, sehingga Anda dapat dengan mudah membuat visual yang menonjol.',
    colorVersion: 'Versi Berwarna',
    whiteVersion: 'Versi Putih',
    brandTrademark: 'Merek Dagang',
    brandTrademarkDesc: 'Ikon Transit terutama terdiri dari huruf besar "T";',
    brandTrademarkDesc_2: 'Bagian teks adalah Transit;',
    brandTrademarkDesc_3:
      'Ikon dan teks bersama-sama membentuk merek dagang Transit.',
    logo: 'Logo',
    fullVertical: 'Versi Vertikal',
    fullHorizontal: 'Versi Horizontal',
    spellingRules: 'Aturan Penulisan',
    spellingRulesDesc: 'Saat mewakili merek: TRANSIT',
    spellingRulesDesc_1: 'Saat mewakili aplikasi: Transit',
    spellingRulesDesc_2:
      'Contoh yang salah: TRANSITAPP, Transitapp, transitapp',
    representingBrand: 'Saat mewakili merek',
    applicationBrand: 'Saat mewakili aplikasi',
    TransitIcon: 'Ikon Transit',
    TransitIconDesc:
      'Gunakan ikon aplikasi saat Transit disebut sebagai aplikasi;',
    TransitIconDesc_1:
      'Gunakan avatar sosial di media sosial seperti Twitter, Facebook, Medium, dan Telegram.',
    roundedIcon: 'Ikon Bulat',
    squareIcon: 'Ikon Kotak',
    socialAvatar: 'Avatar Sosial',
    TransitColor: 'Warna Transit',
    TransitColorDesc:
      'Warna merek Transit adalah biru, yang melambangkan teknologi dan kepercayaan internet. Warna gradasi juga digunakan dalam grafik aplikasi.',
    primary: 'Utama',
    secondary: 'Sekunder',
    colorSystem: 'Sistem Warna',
    brandBlue: 'Biru Merek',
    brandBlack: 'Hitam Merek',
    OffWhite: 'Putih Pucat',
    palette: 'Palet',
  },
};

export default id;
